module.exports = __webpack_public_path__ + "assets/img/ZT8669Plus-M.0bde55de.png";